/**
 * Copyright Mántum All Rights Reserved.
 */
import Select from '../select';
import { forwardRef } from 'react';

import type { Detail, Option, Validation } from '@mantum/kanela';

type PropTypes = {
    disabled?: boolean;
    error?: boolean;
    name?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (name?: string, value?: Option<unknown> | unknown) => void;
    optional?: boolean;
    placeholder?: string;
    testid?: string;
    validation?: Validation;
    value?: Option<unknown>;
};

export default forwardRef<Detail<unknown>, PropTypes>(
    function Country(props, ref) {
        return (
            <Select
                ref={ref}
                dataSource={{
                    url: 'https://restcountries.com/v3.1/all',
                    method: 'GET'
                }}
                advanced={{
                    options: {
                        label: 'name.common',
                        value: 'name.common'
                    }
                }}
                {...props}
            />
        );
    }
);
